import React, { useEffect } from 'react';
import useStore from './store';

const OrderSummary = () => {
  const { cartItems, fetchCart } = useStore();

  useEffect(() => {
    fetchCart();
  }, [fetchCart]);

  const total = cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);

  return (
    <div>
      <h2>Your Order</h2>
      {cartItems.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {cartItems.map((item, index) => (
              <li key={index} style={{ marginBottom: '10px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                <strong>{item.product_name}</strong>
                <div>Qty: {item.quantity}</div>
              </li>
            ))}
          </ul>
          <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '20px' }}>
            Total: ${total.toFixed(2)}
          </div>
        </>
      )}
      <a href="/checkout" style={{
          display: 'block',
          textAlign: 'center',
          padding: '15px',
          backgroundColor: '#ffc107',
          color: 'black',
          textDecoration: 'none',
          borderRadius: '4px',
          marginTop: '20px',
          fontWeight: 'bold'
      }}>
        Checkout
      </a>
    </div>
  );
};

export default OrderSummary;
